// extracted by mini-css-extract-plugin
export default {"robot-container":"Robot_robot-container__xt2mR"};